import { Context } from '@app/packages/routing/Context'
import type { RouterComponentBundleFetchData } from '@app/packages/routing/types'

import type { Store } from '@app/store/store'

export class RouterContext extends Context {
  static create(store: Store) {
    const context = new RouterContext()
    context.set('store', store)
    return context
  }

  getStore(): Store {
    return this.get<Store>('store')!
  }
}

type DefaultParams = { [K in string]?: string | undefined }

type FetchDataCreator = <Params extends DefaultParams = {}>(
  cb: (obj: Omit<Parameters<RouterComponentBundleFetchData<Params>>[0], 'context'> & { store: Store }) => Promise<void>
) => RouterComponentBundleFetchData<Params>

export const createFetchData: FetchDataCreator = cb => {
  return async ({ context, ...rest }) => {
    await cb({ ...rest, store: context.as<RouterContext>().getStore() })
  }
}
